<ion-tabs>
  <ion-tab-bar id="app-tab-bar" slot="bottom">
    <ion-tab-button tab="explore" [disabled]="navigating">
      <ion-icon class="icon at-rest" src="assets/images/icons/tabs/explore.svg" aria-hidden="true"></ion-icon>
      <ion-icon class="icon when-here" src="assets/images/icons/tabs/explore-active.svg" aria-hidden="true"></ion-icon>
      <ion-label>{{ 'TABS.EXPLORE' | translate }}</ion-label>
    </ion-tab-button>
    <ion-tab-button tab="activity" [disabled]="navigating">
      <ion-icon class="icon at-rest" src="assets/images/icons/tabs/activity.svg" aria-hidden="true"></ion-icon>
      <ion-icon class="icon when-here" src="assets/images/icons/tabs/activity-active.svg" aria-hidden="true"></ion-icon>
      <ion-label>{{ 'TABS.ACTIVITY' | translate }}</ion-label>
    </ion-tab-button>
    <ion-tab-button id="create-event-button" [disabled]="navigating" (click)="presentActionSheet()">
      <span class="create-disc">
        <ion-icon class="icon" src="assets/images/icons/tabs/create.svg" aria-hidden="true"></ion-icon>
      </span>
      <ion-label>{{ 'TABS.CREATE_EVENT.TITLE' | translate }}</ion-label>
    </ion-tab-button>
    <ion-tab-button tab="message" [disabled]="navigating">
      <ion-icon class="icon at-rest" src="assets/images/icons/tabs/message.svg" aria-hidden="true"></ion-icon>
      <ion-icon class="icon when-here" src="assets/images/icons/tabs/message-active.svg" aria-hidden="true"></ion-icon>
      @if (unreadMessages$ | async; as unread) {
      <ion-badge>{{ unread }}</ion-badge>
      }
      <ion-label>{{ 'TABS.MESSAGES' | translate }}</ion-label>
    </ion-tab-button>
    <ion-tab-button tab="profile" [disabled]="navigating">
      <ion-icon class="icon at-rest" src="assets/images/icons/tabs/profile.svg" aria-hidden="true"></ion-icon>
      <ion-icon class="icon when-here" src="assets/images/icons/tabs/profile-active.svg" aria-hidden="true"></ion-icon>
      <ion-label>{{ 'TABS.PROFILE' | translate }}</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
